import React, {useMemo} from 'react';
import {getCoreRowModel, useReactTable} from "@tanstack/react-table";
import {useTranslation} from "react-i18next";
import {useTaskErrorsQuery} from "../query";
import useDataTable from "../../../components/DataTable/useDataTable";
import DataTable from "../../../components/DataTable";


const ErrorTable = ({importTaskId}) => {
    const {t} = useTranslation(['importTasks']);
    const {fetchDataOptions, ...tableState} = useDataTable();
    const taskErrorsQuery = useTaskErrorsQuery(importTaskId, fetchDataOptions);

    const {rows, page_count} = taskErrorsQuery.data ? taskErrorsQuery.data : {};

    const columns = useMemo(
        () => [
            {
                accessorKey: 'message',
                cell: info => info.getValue().substring(0, 500),
                header: () => <span>{t("errorTable.message")}</span>,
                enableSorting: false,
                footer: props => props.column.id,
                meta: {
                }
            }
        ],
        []  // eslint-disable-line react-hooks/exhaustive-deps
    )

    const table = useReactTable({
        data: rows ?? [],
        columns,
        pageCount: page_count ?? -1,
        state: {
            pagination: tableState.pagination,
            sorting: tableState.sorting,
        },
        onPaginationChange: tableState.setPagination,
        onGlobalFilterChange: tableState.onGlobalFilterChange,
        onSortingChange: tableState.onSortingChange,
        getCoreRowModel: getCoreRowModel(),
        manualPagination: true,  // rows are expected to be paginated (controlled mode)
        manualSorting: true,  // rows are expected to be sorted (controlled mode)
        // getPaginationRowModel: getPaginationRowModel(), // If only doing manual pagination, you don't need this
        debugTable: true,
    })

    if (taskErrorsQuery.isLoading) {
        return null;
    }

    return <DataTable table={table}/>;

}


export default ErrorTable;